import moment from 'moment/moment';

import { PriceListActionType } from '../models/price-list.model';
import { PriceListSubfamilyDetailsEntityData } from '../models/subfamily-price-data.model';

export const PriceListUtils = {
  isFinalizeAction: (action: PriceListActionType) => {
    return action === 'finalize' || action === 'finalizeWarranty' || action === 'finalizeMarkup';
  },
  isDateWithinValidityPeriod: (
    date: moment.Moment | undefined | null,
    priceListEntityData: PriceListSubfamilyDetailsEntityData | undefined
  ) => {
    if (!priceListEntityData || !date) {
      return false;
    }

    const momentStart = moment(priceListEntityData.startValidityDate).hour(0);
    const momentEnd = moment(priceListEntityData.endValidityDate).hour(0);

    return date.isSameOrAfter(momentStart) && date.isSameOrBefore(momentEnd);
  },
  areValidDraftsPresent: (priceListItems: PriceListSubfamilyDetailsEntityData[] | undefined) => {
    if (!priceListItems) {
      return false;
    }

    return (
      priceListItems.filter(elem => elem.status === 'DRAFT' && moment(elem.startValidityDate).isAfter(moment()))
        .length > 0
    );
  },
  arePriceListEntitiesInvalid: (priceListItems: PriceListSubfamilyDetailsEntityData[] | undefined) => {
    if (!priceListItems) {
      return false;
    }

    return (
      priceListItems.filter(priceListItem => moment(priceListItem.startValidityDate).hour(0).isAfter(moment()))
        .length >= 3
    );
  },
};
